import axios from 'common/bsac-api.js';
import constants from 'common/constants';
import prototype from 'prototype/product-category';

const state = {
  productCategories: [],
};

const getters = {
  /**
   * 商品カテゴリを取得する
   * @param {*} state
   * @returns
   */
  productCategories: (state) => state.productCategories,
  /**
   * 検索用商品カテゴリを取得する
   * @param {*} state
   * @returns
   */
  productCategoriesForSearch: (state) => {
    let categories = [];
    categories.push({
      id: constants.SELECTBOX_NOT_SELECTED.value,
      nameJa: constants.SELECTBOX_NOT_SELECTED.text,
    });
    state.productCategories.forEach((category) => categories.push(category));
    return categories;
  },
};

const mutations = {
  /**
   * データをクリアする
   * @param {*} state
   */
  clearData(state) {
    state.productCategories = [];
  },
  /**
   * 商品カテゴリーをセットする
   * @param {*} state
   * @param {*} categories
   */
  setProductCategories(state, categories) {
    state.productCategories = [];
    categories.forEach(function (category) {
      let newCategory = new prototype.ProductCategory();
      newCategory.setApiData(category);
      state.productCategories.push(newCategory);
    });
  },
};

const actions = {
  /**
   * APIを呼び出し商品カテゴリ一覧を取得する
   * @param {*} param0
   * @param {*} state
   * @returns
   */
  getProductCategories({ commit, rootGetters }) {
    const headers = rootGetters['admin/authHeaders'];
    // console.log(`header: ${JSON.stringify(headers)}`);
    return axios
      .get(`${constants.ADMIN_API_URL}/product_categories`, headers)
      .then((response) => {
        // console.debug('response:' + JSON.stringify(response));
        commit('setProductCategories', response.data.data);
        return {
          success: true,
          status: null,
          message: null,
        };
      })
      .catch((error) => {
        console.error(error.response);
        return {
          success: false,
          status: null,
          message: null,
        };
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
